/**
 * Registers the Modo Caverna service worker in production only. Called from
 * `src/index.js` after the React tree mounts. The registration is fire-and-
 * forget by design — a failed SW must never block the app boot.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Skip SW during dev to avoid stale bundle issues with CRA HMR.
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[pwa] service worker registration failed:", err);
      });
  });
}
